<template>
	<sf-data-table
		ref="mdjRsltTable"
		paging
		:pageUnit="groups.pageUnit"
		:totalSize="groups.totalSize"
		:columns="mdjRsltCols"
		:rows="rows"
		:excel="isButton_(scrId, 'EX')"
		:stripe="false"
		:index="true"
		:customExcel="excelFunc"
		@changedPage="changedPage"
		creatable
	>
		
		<template v-slot:actionsRight>
		  
			<sf-button  line icon="excel"  :onClick="openExcelUp" v-if="isButton_(scrId, 'EU')">  <!-- v-if="isButton_(scrId, 'EU')" -->
				{{ getMessage_('QWCC000927') }}
			</sf-button>
		</template>
		
	</sf-data-table>
</template>

<script>
import { rootComputed } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '../../store/helpers';
import SelectCombo from '@qms/Components/SelectCombo';
import * as yup from 'yup';

/*엑셀다운로드 시작*/
import utils from '@/utils';
import objectToQuerystring from '@/utils/sfaas_temp/objectToQueryString';
import { BASE_URL } from '@/constants';
/*엑셀다운로드 끝*/

import _ from 'lodash';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			
			searchStye: {
				//그리드 버튼 스타일 지정
				top: '8px',
				right: '7px'
			},
			selGridRowIndex: '',
			excelUpDialogShow: false
		};
	},
	components: {
		//SelectCombo
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		rows() {
			return this.gridList;
		},
		mdjRsltCols() {
			return [
				//{
				//	label: '* ' + this.getMessage_('QWCC000956'), //품번
				//	prop: 'partNo',
				//	width: '200px',
				//	align: 'center',
				//	custom: true
				//},
				{
					label: this.getMessage_('QWCC002126'), // 作业时间 
					prop: 'ckuTm',
					width: '180px',
					headerAlign: 'center',
					align: 'center',
					sortable: false
				},
				{
					label: 'Roll ID', // Roll Id
					prop: 'rollId',
					headerAlign: 'center',
					align: 'center',
					width: '180px',
					sortable: false
				},
				{
					label: 'Cell ID ' , // Cell Id
					prop: 'cellId',
					width: '180px',
					align: 'center'
				},
				{
					label: 'Part NO.', // Part No
					prop: 'partNo',
					width: '180px',
					headerAlign: 'center',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC000069'), //项目类型
					prop: 'prvsClNm',
					minWidth: '150px',
					align: 'center',
					sortable: true
				},
				{
					label: this.getMessage_('QWCC001058'), //检验项目名
					prop: 'ckuPrvsNm',
					minWidth: '260px',
					align: 'center',
					sortable: true
				},
				{
					label:  this.getMessage_('SWCC000481'), // 值
					prop: 'prvsVal',
					width: '100px',
					headerAlign: 'center',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC001222'), // 设备判定结果  
					prop: 'rsltCd',
					width: '120px',
					headerAlign: 'center',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC002124'), // 目标值
					prop: 'avgVal',
					width: '100px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC001205'), // 规格上限 
					prop: 'maxVal',
					width: '100px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC001204'), // 规格下限
					prop: 'minVal',
					width: '100px',
					align: 'center'
				},
				{
					label: this.getMessage_('QWCC002125'), // 判定 
					prop: 'jgmtCrtnCd',
					width: '100px',
					align: 'center'
				}
			];
		}
	},
	methods: {
		...serviceMethods,
		...utils, //커스텀 엑셀다운로드시
		

		openExcelUp() {
			this.excelUpDialogShow = true;
			this.$emit('excelUpOpen', this.getMessage_('QWCC002121'));
		},
		excelFunc() {
			//커스텀 엑셀다운로드시 필요한 함수
			let queryStr = '';

			queryStr = objectToQuerystring({
				stdDt: this.searchParams.stdDt,
				partNo: this.searchParams.partNo
			});

			const url = `${BASE_URL}/comm/qmsbase/partCost/v1/asPartInfos/excel` + queryStr;

			const params = { url, columns: this.asPartInfoExcelCols };
			this.xlsxDown(params).catch(error => {
				this.$sf_toast({ type: 'error', message: error.message });
			});
		},
		getSelectedRows() {
			const defaultObj = this.insVali.cast();
			const rows = this.$refs.asPartInfoTable
				.getSelectedRows()
				.map(row => _(row).omitBy(_.isNull).omitBy(_.isUndefined).defaults(defaultObj).value());
			return rows;
		},
		resetTable() {
			this.$emit('Refresh');
		},
		isDisabled({ row }) {
			if (row.rowType && row.rowType === 'add') return false;
			else return true;
		},
		changedPage({ currentPageVal, pageUnitVal, prePage, prePageUnit }) {
			if (!prePage || prePageUnit) {
				//초기값 셋팅시 이미 searchBar에서 데이터를 조회햇기 때문에 중복 조회 하지 않도록 처리
				// return;
			}
			this.setPagingInfo_({ key: 'currentPage', value: currentPageVal });
			this.setPagingInfo_({ key: 'pageUnit', value: pageUnitVal });
			this.$emit('Refresh', currentPageVal, pageUnitVal);
		}
	}
};
</script>

<style></style>
